    <div class="documents">
      <ri-filemanager style="display: block;">Loading...</ri-filemanager>
    </div>
